import { _ } from "../../core/polyglot/polyglot.js";
import { select } from "../../core/elements/index.js";
import itemsSettingsWidget from "./itemsSettingsWidget.js";

/**
 * Widget displaying settings (dimensions, budgets) for the columns of a report.
 */
export default itemsSettingsWidget.subclass((that, my) => {
	my.itemSettingsRenderer = function (column) {
		return (html) => {
			if (column.hasChoiceForBudget()) {
				html.render(my.budgetDropdownRenderer(column));
			}
			if (column.hasOwnDimensionSpecification()) {
				html.render(my.dimensionPickerRenderer(column));
			}
		};
	};

	my.budgetDropdownRenderer = function (column) {
		return (html) => {
			html.div(
				{ klass: "setting-block" },
				_("Budget"),
				select({
					items: column.candidateBudgets().map((budget) => ({
						label: budget.getName(),
						value: budget,
					})),
					selected: column.getBudget(),
					onChange: (budget) => {
						const budgetId = budget.getId();

						my.registerSetting(
							column.getTemplate(),
							"budgetId",
							budgetId,
						);
					},
				}),
			);
		};
	};

	my.getItems = function () {
		return my.report.getColumns();
	};

	my.getDimensionTree = function (column) {
		return column.getDimensionTree();
	};
});
